import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, logoTitle, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/jwtXW2Bc6tUEEYtcnIIt/locations/MvLV4OUJjaddWhfyWwXM'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          w="100vw"
          bg="rgba(0,0,0,.8)"
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
          pt="10px"
        >
          <CFView row center>
            <CFImage h="65px" src={logo} alt="Burnaby Palace Logo" />
            <CFImage
              w="60vw"
              ml="10px"
              src={logoTitle}
              alt="Burnaby Palace Logo Title"
            />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          row
          justifyStart
          h="100px"
          bg="transparent"
          zIndex={98}
          bg="rgba(0,0,0,.8)"
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
        >
          <CFView
            row
            justifyBetween
            alignCenter
            w="100%"
            maxWidth="1400px"
            ph="30px"
          >
            <CFView row justifyStart mt="10px">
              <CFImage
                h="85px"
                src={logo}
                alt="Burnaby Palace Logo"
                zIndex={98}
              />
              <CFImage
                h="85px"
                ml="10px"
                src={logoTitle}
                alt="Burnaby Palace Logo Title"
              />
              {/* <CFSelect selector={dispatch.restaurant.getHasMultipleLocations}>
                <CFView mt="15px" zIndex={99}>
                  <LocationSelect />
                </CFView>
              </CFSelect> */}
            </CFView>
            {/* <CFView hover mt="10px">
              <CFLink
                href="https://res.cloudinary.com/codefusiontech/image/upload/v1594970056/burnabypalace/burnabypalace_menu.pdf"
                newTab
              >
                <CFImage
                  h="50px"
                  src={viewMenu}
                  alt="Burnaby Palace View Menu Button"
                />
              </CFLink>
            </CFView> */}
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
